import * as types from "./actionTypes";

export const showStream = () => ({ type: types.SHOW_STREAM });
export const hideStream = () => ({ type: types.HIDE_STREAM });
export const toggleChat = () => ({ type: types.TOGGLE_CHAT });
export const togglePlayerMode = () => ({ type: types.TOGGLE_PLAYER_MODE });
export const newChatMessages = (count) => ({ type: types.NEW_CHAT_MESSAGES, count });
